var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7011 3.73068C17.2339 3.19798 17.2344 2.33444 16.7023 1.80111V1.80111C16.1693 1.2669 15.304 1.26639 14.7704 1.79998L9.00096 7.56946L3.23148 1.79998C2.69771 1.2662 1.83229 1.26621 1.29852 1.79998V1.79998C0.764741 2.33375 0.764741 3.19917 1.29851 3.73295L7.06799 9.50243L1.29852 15.2719C0.764924 15.8055 0.765432 16.6708 1.29965 17.2037V17.2037C1.83298 17.7358 2.69651 17.7353 3.22922 17.2026L9.00096 11.4309L14.7727 17.2026C15.3052 17.7351 16.1686 17.7351 16.7011 17.2026V17.2026C17.2337 16.6701 17.2337 15.8067 16.7011 15.2742L10.9294 9.50243L16.7011 3.73068Z",
    fill: "currentColor",
    fillOpacity: 0.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2b528fe52e113bf3f54f30a2a4bd4365.svg";
export { ForwardRef as ReactComponent };